/**
 * Check if the current page is using the Mana UI theme.
 * @return {boolean}
 */
export const hasManaUITheme = () => {
  return (document?.body?.dataset?.manaUiTheme ?? 'false') === 'true';
};
